module.exports = __webpack_public_path__ + "static/media/notify.4c877330.svg";